import { StrictMode } from 'react';

import * as Sentry from '@sentry/react';
import TagManager from '@sooro-io/react-gtm-module';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';

import './index.css';
import App from './App.tsx';
const queryClient = new QueryClient();

if (import.meta.env.MODE === 'production') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    tracesSampleRate: 0.7,
    release: import.meta.env.VITE_SENTRY_RELEASE,
  });

  ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);
  TagManager.initialize({ gtmId: import.meta.env.VITE_GTM_ID });
}

const container = document.getElementById('root')!;

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
